import { useCallback, useEffect } from "react";

import { defaultCardCopy } from "./signalCTAs";
import { useAppDispatch, useAppSelector } from "../../Store/Hooks";
import { fetchSignalPresentation } from "../../Store/Reducers/SignalFeedSlice";

/**
 * A signal's display title: the one an Izba admin published in Signal
 * Administration (CTA editor → Card text), else the default. For pages
 * that name a signal without rendering its card — Portfolio Map tooltips
 * and Signal History — so an edited title reads the same everywhere.
 */
export const useSignalTitle = () => {
  const dispatch = useAppDispatch();
  const presentation = useAppSelector(state => state.signalFeed.presentation);
  useEffect(() => {
    if (!presentation) void dispatch(fetchSignalPresentation());
  }, [dispatch, presentation]);
  const titles = presentation?.signal_titles;
  return useCallback(
    (signalKey: string, variant?: string | null): string =>
      (variant ? titles?.[`${signalKey}:${variant}`] : undefined) ??
      titles?.[signalKey] ??
      defaultCardCopy(signalKey, variant).title,
    [titles]
  );
};
